import React, { useEffect, useState } from "react";
import { Bar, Pie, Line } from "react-chartjs-2";
import axiosInstance from "../../../../axios";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Title,
} from "chart.js";

import { Loading } from "../../../Other/Loading";
const geoUrl =
  "https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson";

export default function Charts() {
  const [pendingApproval, setPendingApproval] = useState({});
  const [loading, setloading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axiosInstance.get("admin/statistics");
        setPendingApproval(res?.data?.data?.pendingApprovals);
        setloading(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);

  const data = {
    labels: ["Courses for Category", "Pending Students", "Pending Instructors"],
    datasets: [
      {
        data: [
          pendingApproval?.courses,
          pendingApproval?.students,
          pendingApproval?.teachers,
        ],
        backgroundColor: [
          "rgba(39, 134, 157, 1)",
          "rgba(91, 5, 150, 1)",
          "rgba(8, 207, 255, 1)",
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      <div
        id="myChart"
        onClick={() => setShowModal(true)}
        className="cursor-pointer"
      >
        {loading ? (
          <Loading />
        ) : (
          <Pie data={data} options={options} height={76} width={75} />
        )}
      </div>

      {showModal && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setShowModal(false)}
          ></div>

          <div
            className={`fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white z-[1050] shadow-lg transform transition-transform duration-300 ${showModal ? "translate-x-0" : "translate-x-full"}`}
          >
            <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
              <h2 className="text-lg font-semibold">Full View of Chart</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>

            <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
              {loading ? (
                <Loading />
              ) : (
                <Pie
                  data={data}
                  options={{
                    ...options,
                    plugins: {
                      ...options.plugins,
                      legend: {
                        ...options.plugins.legend,
                        position: "bottom",
                      },
                    },
                  }}
                  height={300}
                  width={300}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export const DashboardLine = ({ chartTitle, instructor }) => {
  ChartJS.register(
    CategoryScale,
    BarElement,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  );
  const [pendingApproval, setPendingApproval] = useState([]);
  const [loading, setloading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  function fetch() {
    const fetchData = async () => {
      try {
        let res;
        if (instructor) {
          res = await axiosInstance.get("instructor/statistics");
          setPendingApproval(res?.data?.data?.enrollmentsByMonths);
        } else {
          res = await axiosInstance.get("admin/statistics");
          setPendingApproval(res?.data?.data?.userTypeByMonths);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setloading(false);
      }
    };

    fetchData();
  }

  useEffect(() => {
    fetch();
  }, []);


  const getmonth = pendingApproval?.map((ele) => {
    const d = new Date();
    d.setMonth(ele?.monthNumber - 1);
    const monthName = d.toLocaleString("default", { month: "short" });
    return monthName;
  });

  const data = instructor
    ? {
      labels: getmonth,
      datasets: [
        {
          label: "Students",
          data: pendingApproval?.map((ele) => ele?.total),
          backgroundColor: "rgba(39, 134, 157,1)",
          categoryPercentage: 0.2,
          borderRadius: Number.MAX_VALUE,
          borderSkipped: false,
        },
      ],
    }
    : {
      labels: getmonth,
      datasets: [
        {
          label: "Students",
          data: pendingApproval?.map((ele) => ele?.students),
          backgroundColor: "rgba(39, 134, 157,1)",
          categoryPercentage: 0.2,
          borderRadius: Number.MAX_VALUE,
          borderSkipped: false,
        },
        {
          label: "Instructors",
          data: pendingApproval?.map((ele) => ele?.teachers),
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          categoryPercentage: 0.2,
          borderRadius: Number.MAX_VALUE,
          borderSkipped: false,
        },
      ],
    };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 6,
          },
        },
      },
      title: {
        display: true,
        text: chartTitle,
        font: {
          size: 10,
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <>
      <div
        id="myChart-1"
        onClick={() => setShowModal(true)}
        style={{ cursor: "pointer" }}
      >
        {loading ? (
          <Loading />
        ) : (
          <Bar
            data={data}
            options={options}
            width="30%"
            height={instructor ? "15%" : "40%"}
          />
        )}
      </div>

      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-2/5 bg-white shadow-lg z-[1050] transform transition-transform duration-300 ${showModal ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex justify-between items-center px-4 py-3 border-b border-gray-300">
          <h2 className="text-lg font-semibold">{chartTitle}</h2>
          <button
            onClick={() => setShowModal(false)}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            &times;
          </button>
        </div>
        <div className="p-4 overflow-y-auto h-[calc(100%-3rem)]">
          {loading ? (
            <Loading />
          ) : (
            <Bar
              data={data}
              options={{
                ...options,
                plugins: {
                  ...options.plugins,
                  title: {
                    ...options.plugins.title,
                    font: { size: 16 },
                  },
                },
              }}
              width="100%"
              height="50%"
            />
          )}
        </div>
      </div>

      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
          onClick={() => setShowModal(false)}
        ></div>
      )}
    </>
  );
};

export const DashboardSchool = ({ chartTitle, instructor }) => {
  const [webinarData, setWebinarData] = useState([]);
  const [loading, setloading] = useState(true);
  const [showPanel, setShowPanel] = useState(false);

  function fetch() {
    const fetchData = async () => {
      if (!instructor) return;

      try {
        const res = await axiosInstance.get("instructor/statistics");
        setWebinarData(res?.data?.data?.webinarsByMonths);
      } catch (error) {
        console.error("Error fetching webinar data:", error);
      } finally {
        setloading(false);
      }
    };

    fetchData();
  }

  useEffect(() => {
    fetch();
  }, []);


  const getmonth = webinarData?.map((ele) => {
    const d = new Date();
    d.setMonth(ele?.monthNumber - 1);
    return d.toLocaleString("default", { month: "short" });
  });

  const data = {
    labels: getmonth,
    datasets: [
      {
        fill: true,
        lineTension: 0.4,
        label: instructor ? "" : "schools",
        data: instructor ? webinarData.map((ele) => ele.total) : [],
        backgroundColor: instructor ? "#e8f6fa" : "rgba(239, 215, 250, 1)",
        borderColor: instructor ? "#147AD6" : "#c172f6",
        pointRadius: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: !instructor && {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 6,
          },
        },
      },
      title: {
        display: true,
        text: chartTitle,
        font: { size: 8 },
      },
    },
    scales: {
      x: {
        grid: { color: "white", borderColor: "white" },
        ticks: { font: { size: 10 } },
      },
      y: {
        grid: { color: "white", borderColor: "white" },
        ticks: { font: { size: 8 } },
      },
    },
  };

  return (
    <>
      {/* Chart Preview */}
      <div onClick={() => setShowPanel(true)} style={{ cursor: "pointer" }}>
        {loading && instructor ? (
          <Loading />
        ) : (
          <Line
            data={data}
            options={options}
            width="30%"
            height={instructor ? "15%" : "40%"}
          />
        )}
      </div>

      {/* Tailwind Off-Canvas Panel */}
      <div
        className={`fixed inset-0 z-[1050] transition-transform duration-300 ${showPanel ? "translate-x-0" : "translate-x-full"} bg-black bg-opacity-30`}
      >
        <div className="!absolute right-0 top-0 h-full w-full sm:w-3/4 md:w-1/2 lg:w-1/3 bg-white shadow-lg p-6 overflow-auto">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">{chartTitle}</h2>
            <button
              onClick={() => setShowPanel(false)}
              className="text-gray-500 hover:text-gray-700 text-xl font-bold"
            >
              ✖
            </button>
          </div>
          <div>
            {loading ? (
              <Loading />
            ) : (
              <Line
                data={data}
                options={{
                  ...options,
                  plugins: {
                    ...options.plugins,
                    title: {
                      ...options.plugins.title,
                      font: { size: 16 },
                    },
                  },
                }}
                width="100%"
                height="50%"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export const DashboardCombineChart = ({ instructor }) => {
  const [showModal, setShowModal] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const fetchRevenueData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/admin/revenue?year=${selectedYear}`
        );
        setRevenueData(response.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching revenue data:", error);
        setLoading(false);
      }
    };

    fetchRevenueData();
  }, [selectedYear]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const data = {
    labels,
    datasets: instructor
      ? [
        {
          type: "line",
          label: "Total Revenue",
          borderColor: "#27869d",
          backgroundColor: "#27869d",
          data: revenueData?.map((row) => row.instructorRevenue), // Only instructor revenue
        },
      ]
      : [
        {
          type: "line",
          label: "Instructor Revenue",
          borderColor: "#27869d",
          backgroundColor: "#27869d",
          data: revenueData?.map((row) => row.instructorRevenue),
        },
        {
          type: "line",
          label: "Admin Revenue",
          backgroundColor: "#f70fc5",
          borderColor: "#f70fc5",
          data: revenueData?.map((row) => row.adminRevenue),
        },
        {
          type: "bar",
          label: "Instructor Course Revenue",
          backgroundColor: "#d9e4e6",
          data: revenueData?.map((row) => row.instructorCourseRevenue),
        },
      ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <>
      <div className="flex-selectbox-new !py-2">
        <p className="paragraph-css">
          {instructor
            ? "Total Revenue"
            : "Actual revenue, Instructor revenue & Admin revenue"}
        </p>
        <select
          id="year"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="ml-2 border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {[...Array(10)].map((_, i) => {
            const year = new Date().getFullYear() - i;
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>
      </div>

      {/* Chart Preview */}
      <div onClick={() => setShowModal(true)} className="cursor-pointer">
        {loading ? (
          <p><Loading /></p>
        ) : (
          <Bar
            data={data}
            options={options}
            height={instructor ? "210px" : "204px"}
          />
        )}
      </div>

      {/* Offcanvas Overlay */}
      {showModal && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setShowModal(false)}
          ></div>

          {/* Offcanvas Panel */}
          <div
            className={`fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-lg z-[1050] transform transition-transform duration-1000 ${showModal ? "translate-x-0" : "translate-x-full"}`}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <h2 className="text-lg font-semibold">Full View of Chart</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>
            <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
              {loading ? (
                <p><Loading /></p>
              ) : (
                <Bar
                  data={data}
                  options={{
                    ...options,
                    plugins: {
                      ...options.plugins,
                      title: {
                        display: true,
                        text: `Full View of Combined Chart (${selectedYear})`,
                        font: { size: 16 },
                      },
                    },
                  }}
                  height={400}
                  width={600}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export const ActiveUsersByCountry = () => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPanel, setShowPanel] = useState(false);

  const countryCoordinates = {
    UnitedStates: { lat: 37.0902, lng: -95.7129 }, // United States
    India: { lat: 20.5937, lng: 78.9629 },  // India
    UnitedKingdom: { lat: 55.3781, lng: -3.4360 },  // United Kingdom
    Australia: { lat: -25.2744, lng: 133.7751 },// Australia
    Canada: { lat: 56.1304, lng: -106.3468 },// Canada
    Brazil: { lat: -14.2350, lng: -51.9253 },// Brazil
    China: { lat: 35.8617, lng: 104.1954 }, // China
    Russia: { lat: 61.5240, lng: 105.3188 }, // Russia
    DE: { lat: 51.1657, lng: 10.4515 },  // Germany
    FR: { lat: 46.6034, lng: 1.8883 },   // France
    JP: { lat: 36.2048, lng: 138.2529 }, // Japan
    MX: { lat: 23.6345, lng: -102.5528 },// Mexico
    IT: { lat: 41.8719, lng: 12.5674 },  // Italy
    ES: { lat: 40.4637, lng: -3.7492 },  // Spain
    KR: { lat: 35.9078, lng: 127.7669 }, // South Korea
    ID: { lat: -0.7893, lng: 113.9213 }, // Indonesia
    TR: { lat: 38.9637, lng: 35.2433 },  // Turkey
    ZA: { lat: -30.5595, lng: 22.9375 }, // South Africa
    NG: { lat: 9.0820, lng: 8.6753 },    // Nigeria
    AR: { lat: -38.4161, lng: -63.6167 },// Argentina
    SA: { lat: 23.8859, lng: 45.0792 },  // Saudi Arabia
    IR: { lat: 32.4279, lng: 53.6880 },  // Iran
    EG: { lat: 26.8206, lng: 30.8025 },  // Egypt
    TH: { lat: 15.8700, lng: 100.9925 }, // Thailand
    VN: { lat: 14.0583, lng: 108.2772 }, // Vietnam
    PK: { lat: 30.3753, lng: 69.3451 },  // Pakistan
    BD: { lat: 23.6850, lng: 90.3563 },  // Bangladesh
    PL: { lat: 51.9194, lng: 19.1451 },  // Poland
    NL: { lat: 52.1326, lng: 5.2913 },   // Netherlands
    BE: { lat: 50.5039, lng: 4.4699 },   // Belgium
    SE: { lat: 60.1282, lng: 18.6435 },  // Sweden
    CH: { lat: 46.8182, lng: 8.2275 },   // Switzerland
    NO: { lat: 60.4720, lng: 8.4689 },   // Norway
    DK: { lat: 56.2639, lng: 9.5018 },   // Denmark
    FI: { lat: 61.9241, lng: 25.7482 },  // Finland
    GR: { lat: 39.0742, lng: 21.8243 },  // Greece
    PT: { lat: 39.3999, lng: -8.2245 },  // Portugal
    NZ: { lat: -40.9006, lng: 174.8860 },// New Zealand
    MY: { lat: 4.2105, lng: 101.9758 },  // Malaysia
    SG: { lat: 1.3521, lng: 103.8198 },  // Singapore
    PH: { lat: 12.8797, lng: 121.7740 }, // Philippines
    KE: { lat: -1.2921, lng: 36.8219 },  // Kenya
    MA: { lat: 31.7917, lng: -7.0926 },  // Morocco
    IQ: { lat: 33.2232, lng: 43.6793 },  // Iraq
    UA: { lat: 48.3794, lng: 31.1656 },  // Ukraine
    IL: { lat: 31.0461, lng: 34.8516 },  // Israel
    AE: { lat: 23.4241, lng: 53.8478 },  // United Arab Emirates
    QA: { lat: 25.276987, lng: 51.520008 }, // Qatar
    CL: { lat: -35.6751, lng: -71.5430 } // Chile
  };


  useEffect(() => {
    const fetchUserDataByCountry = async () => {
      try {
        const res = await axiosInstance.get("/admin/user-by-country");
        console.log("res",res);
        setUserData(res.data.data || []);
      } catch (err) {
        console.error("Error fetching user data by country:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDataByCountry();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setShowPanel(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  const renderMap = () => (
    <ComposableMap projectionConfig={{ scale: 150 }}>
      <Geographies geography={geoUrl}>
        {({ geographies }) =>
          geographies.map((geo) => (
            <Geography
              key={geo.rsmKey}
              geography={geo}
              style={{
                default: { fill: "#E0E0E0", outline: "none" },
                hover: { fill: "#27869d", outline: "none" },
                pressed: { fill: "#27869d", outline: "none" },
              }}
            />
          ))
        }
      </Geographies>
      {userData.map((country, idx) => {
        const coords = countryCoordinates[country.countryCode];
        console.log("Coordinates for", country.countryCode, coords);
        if (!coords) return null;
        return (
          <Marker key={idx} coordinates={[coords.lng, coords.lat]}>
            <circle r={6} fill="#F53" stroke="#fff" strokeWidth={1} />
            <text
              textAnchor="middle"
              y={-10}
              style={{
                fontFamily: "system-ui",
                fill: "#5D5A6D",
                fontSize: "10px",
              }}
            >
              {country.totalCount}
            </text>
          </Marker>
        );
      })}
    </ComposableMap>
  );

  return (
    <>
      <p className="text-xl font-semibold mb-4">Active Users By Country</p>
      <div onClick={() => setShowPanel(true)} className="cursor-pointer">
        {loading ? <Loading /> : renderMap()}
      </div>

      {/* Offcanvas Side Panel */}
      {showPanel && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setShowPanel(false)}
          />
          <div className="fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white z-[1050] shadow-lg transform transition-transform duration-300">
            <div className="flex justify-between items-center px-4 py-3 border-b">
              <h2 className="text-lg font-semibold">Country-wise User Stats</h2>
              <button
                onClick={() => setShowPanel(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>
            <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
              {renderMap()}
              <table className="w-full border-collapse border border-gray-300 text-sm">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-2 py-1 text-left">
                      Country
                    </th>
                    <th className="border border-gray-300 px-2 py-1 text-right">
                      Active Users
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userData.map((c, i) => (
                    <tr key={i}>
                      <td className="border border-gray-300 px-2 py-1">
                        {c.countryCode}
                      </td>
                      <td className="border border-gray-300 px-2 py-1 text-right">
                        {c.totalCount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
};


export const CountChart = () => {
  const [pendingApproval, setPendingApproval] = useState({});
  const [loading, setloading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axiosInstance.get("admin/statistics");
        setPendingApproval(res?.data?.data?.countofCharts);
        setloading(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetch();
  }, []);

  const data = {
    labels: ["No of Visitors", "No of Enquired", "No of Enrolled"],
    datasets: [
      {
        data: [
          pendingApproval?.totalCourseViews,
          pendingApproval?.totalEnquiries,
          pendingApproval?.totalEnrolled,
        ],
        backgroundColor: [
          "rgba(39, 134, 157, 1)",
          "rgba(91, 5, 150, 1)",
          "rgba(8, 207, 255, 1)",
        ],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <>
      <div
        id="myChart"
        onClick={() => setShowModal(true)}
        className="cursor-pointer"
      >
        {loading ? (
          <Loading />
        ) : (
          <Pie data={data} options={options} height={76} width={75} />
        )}
      </div>

      {showModal && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setShowModal(false)}
          ></div>

          <div
            className={`fixed top-0 right-0 h-full w-full sm:w-[500px] bg-white z-[1050] shadow-lg transform transition-transform duration-300 ${showModal ? "translate-x-0" : "translate-x-full"}`}
          >
            <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
              <h2 className="text-lg font-semibold">Full View of Chart</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>

            <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
              {loading ? (
                <Loading />
              ) : (
                <Pie
                  data={data}
                  options={{
                    ...options,
                    plugins: {
                      ...options.plugins,
                      legend: {
                        ...options.plugins.legend,
                        position: "bottom",
                      },
                    },
                  }}
                  height={300}
                  width={300}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export const CourseViewHistory = () => {
  const [showModal, setShowModal] = useState(false);
  const [revenueData, setRevenueData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(String(new Date().getMonth() + 1).padStart(2, "0"));

  useEffect(() => {
    const fetchRevenueData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get("admin/statistics/course", {
          params: {
            year: selectedYear,
            month: selectedMonth,
          },
        });
        setRevenueData(response?.data?.data?.courseHistory || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching revenue data:", error);
        setLoading(false);
      }
    };

    fetchRevenueData();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  // Optional: Sort courses by views descending
  const sortedData = [...revenueData].sort((a, b) => b.courseViews - a.courseViews);

  const data = {
    labels: sortedData.map((row) => row.CourseName),
    datasets: [
      {
        type: "bar",
        label: "Course Views",
        backgroundColor: "#27869d",
        borderColor: "#27869d",
        data: sortedData.map((row) => row.courseViews),
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10,
            weight: 600,
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          color: "white",
          borderColor: "white",
        },
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
  };

  return (
    <>
      <div className="flex-selectbox-new !py-2">
        <p className="paragraph-css">Course-wise View Chart</p>
        <div className="flex items-center gap-2 py-2">
          <label className="text-sm font-medium">Month:</label>
          <select
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          >
            {Array.from({ length: 12 }, (_, i) => {
              const month = String(i + 1).padStart(2, "0");
              return (
                <option key={month} value={month}>
                  {month}
                </option>
              );
            })}
          </select>

          <label className="text-sm font-medium ml-2">Year:</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          >
            {[...Array(10)].map((_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>

      </div>

      {/* Chart Preview */}
      <div onClick={() => setShowModal(true)} className="cursor-pointer">
        {loading ? (
          <p><Loading /></p>
        ) : (
          <Bar
            data={data}
            options={options}
            height={"210px"}
          />
        )}
      </div>

      {/* Modal Overlay */}
      {showModal && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-[999]"
            onClick={() => setShowModal(false)}
          ></div>

          {/* Modal Panel */}
          <div
            className={`fixed top-0 right-0 h-full w-full sm:w-[600px] bg-white shadow-lg z-[1050] transform transition-transform duration-1000 ${showModal ? "translate-x-0" : "translate-x-full"}`}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b">
              <h2 className="text-lg font-semibold">Full View of Course Views Chart</h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✖
              </button>
            </div>
            <div className="p-4 overflow-y-auto h-[calc(100%-60px)]">
              {loading ? (
                <p><Loading /></p>
              ) : (
                <Bar
                  data={data}
                  options={{
                    ...options,
                    plugins: {
                      ...options.plugins,
                      title: {
                        display: true,
                        text: `Detailed Course View Chart (${selectedYear})`,
                        font: { size: 16 },
                      },
                    },
                  }}
                  height={400}
                  width={600}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};